module.exports = "<router-outlet></router-outlet>\n<!--<button class=\"btnAdd\">Install PWA</button>-->\n<app-snackbar></app-snackbar>\n"